import React from "react";
import { defineMessages } from "react-intl";
import { makeStyles } from "tss-react/mui";
import "../button/Buttons.js";
import "../button/EditButton.js";
import "@mui/material";
import "@mui/material/Popover";
import "../../localization/MessageLocalizer.js";
import "../../localization/LocaleProvider.js";
import "../../localization/sharedResources.js";
import "../dropdown/DropdownHoc.style.js";
import { DropdownWithChip } from "../dropdown/DropdownWithChip.js";
import "../dropdown/DropdownItem.js";
const localized = defineMessages({
  any: {
    id: "AutocompleteButton_any",
    defaultMessage: "Any"
  }
});
const useStyles = makeStyles()((theme) => ({
  autocompleteButton: {
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  autocompleteButtonDropdownContainer: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2, 1.5, 1.5),
    boxSizing: "content-box",
    [theme.breakpoints.down("sm")]: {
      width: "unset"
    }
  }
}));
function AutocompleteButton({
  label,
  selectedText,
  applyActionLabel,
  cancelActionLabel,
  onApply,
  onCancel,
  children,
  className
}) {
  const { classes, cx } = useStyles();
  return /* @__PURE__ */ React.createElement(
    DropdownWithChip,
    {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      label,
      selectedText: selectedText ?? localized.any,
      styles: {
        dropdownButton: cx(classes.autocompleteButton, className),
        dropdownButtonOpen: cx(classes.autocompleteButton, className),
        dropdownContainer: classes.autocompleteButtonDropdownContainer
      },
      applyAction: applyActionLabel ?? !!onApply,
      cancelAction: cancelActionLabel ?? !!onCancel,
      onApplyClick: onApply,
      onCancelClick: onCancel
    },
    children
  );
}
export {
  AutocompleteButton
};
//# sourceMappingURL=AutocompleteButton.js.map
